<h2 mat-dialog-title>{{ (!onEdit ? 'filters.dialog.add_title' : 'filters.dialog.edit_title') | translate |
    uppercase}}</h2>
<mat-dialog-content>
    <form [formGroup]="filtersForm">
        <div class="form-container">
            <mat-form-field appearance="fill">
                <mat-label floatLabel="never">{{ 'filters.dialog.form.label' | translate | uppercase}}</mat-label>
                <input matInput formControlName="label"
                    placeholder="{{ 'filters.dialog.form.label_placeholder' | translate }}" #input>
            </mat-form-field>
            <br>
            <mat-checkbox class="example-margin checked-green" formControlName="default">{{
                'filters.dialog.form.default' | translate | uppercase}}</mat-checkbox>

        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="delete-btn" *ngIf="onEdit" mat-button (click)="delete()">
        <mat-icon>delete</mat-icon> {{ 'filters.actions.delete' | translate |
        uppercase}}
    </button>
    <button class="info-btn" mat-button [ngClass]="{'disabled': !filtersForm.valid}" [disabled]="!filtersForm.valid"
        (click)="!onEdit ? save() : update()">
        <mat-icon>save</mat-icon> {{ (!onEdit ? 'filters.actions.save' : 'filters.actions.update') | translate |
        uppercase}}
    </button>
    <button mat-button mat-dialog-close>
        <mat-icon>cancel</mat-icon> {{ 'filters.actions.cancel' | translate | uppercase}}
    </button>
</mat-dialog-actions>